import type { ComponentType } from "react";

export const getDisplayName = <P extends {}>(Component: ComponentType<P>) =>
    Component.displayName || Component.name || "Component";
